<template>
  <section class="calendly-availability-admin">
    <div class="row">
      <div class="col-12">
        <!-- Feature 2: Availability Manager Component -->
        <AvailabilityManager />
      </div>
    </div>
  </section>
</template>

<script>
import AvailabilityManager from "@/components/Calendly/AvailabilityManager.vue";

export default {
  name: "AdminCalendlyAvailability",
  components: {
    AvailabilityManager,
  },
};
</script>

<style scoped>
.calendly-availability-admin {
  width: 100%;
}
</style>
